<template>
    <v-row
        no-gutters
        class="pl-9 pt-8"
    >
        <v-col cols="9">
            <v-row no-gutters>
                <v-col cols="5">
                    <dropdown
                        :items="layoutChoices"
                        :selected="layoutChoices.filter(x => x.code === selectedLayout)"
                        name-key="name"
                        value-key="code"
                        show-selected-first
                        :label="$t('Default layout')"
                        @input="selectedLayout = $event.code"
                    />
                    <div class="primary--text body-1 cursor-pointer mt-4" @click="changeAgreement()">
                        {{ $t('Change agreement ID') }}
                    </div>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="3">
            <v-row
                class="n1 sidebar_block"
                no-gutters
                justify="center"
                align="center"
            >
                <v-col class="shrink">
                    <v-row
                        no-gutters
                        class="flex-nowrap"
                        align="center"
                    >
                        <v-col class="mr-3">
                            <v-icon color="primary">
                                mdi-book-open-blank-variant
                            </v-icon>
                        </v-col>
                        <v-col
                            class="primary--text body-2"
                            style="white-space: nowrap"
                        >
                            <a :href="HelpModule.getHelpLink('app_economic')" target="_blank">
                                {{ $t('How to set up') }}
                            </a>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import IntegrationSettingsControl from "@/views/AppStore/Integrations/IntegrationSettingsControl";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import CustomFieldsModule from "../../../../store/modules/custom_fields";
import {computed, ref, watch} from "@vue/composition-api";
import {$t} from "../../../../i18n";
import {TAB_NAMES} from "../../app-tabs";
import FeatureModule from "../../../../store/modules/feature"
import HelpModule from "@/modules/help/help";
import AppModule from "../../../../store/modules/app"

export default {
    name: "EconomicDialogSettingsTab",
    components: {
        IntegrationSettingsControl
    },
    props: {
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const {account_custom_fields, fetchCustomFields} = CustomFieldsModule();
        const featureModule = FeatureModule();
        const appModule = AppModule();
        const {
            appStoreDialogGetters,
            appStoreDialogActions
        } = appStoreDialog()

        const loading = ref(false);
        const selectedLayout = ref(null);

        const accountFeature = appStoreDialogGetters.getCurrentFeature()
        const accountFeatureSettings = appStoreDialogGetters.getCurrentFeatureSettings()
        const selectedAccount = appStoreDialogGetters.getSelectedCompany()

        const customFields = computed(() => account_custom_fields(selectedAccount.id).value);
        const layoutNumberField = computed(() => customFields.value.find(x => x.name === 'economic_layout_number'))
        const layoutChoices = computed(() => layoutNumberField.value ? layoutNumberField.value._data.choices : [])

        let account_id = selectedAccount.id;
        fetchCustomFields(account_id, 'client', 0, true);

        const handleUpdate = function () {
            appStoreDialogActions.updateCurrentTabWithDelay(TAB_NAMES.OVERVIEW)
        }

        const changeAgreement = () => {
            appStoreDialogActions.updateCurrentTabWithDelay(TAB_NAMES.IMPORT, {
                showConnect: true
            })
        }

        selectedLayout.value = accountFeatureSettings.data.default_economic_layout_number

        const save = () => {
            loading.value = true;

            featureModule.execAppAction({
                account_id: selectedAccount.id,
                feature_id: accountFeature.feature_id,
                action: "save_settings",
                data: {
                    default_economic_layout_number: selectedLayout.value
                }
            })
                .then(resp => {
                    loading.value = false;
                    appStoreDialogActions.updateCurrentTab(0)
                })
                .catch(ex => {
                    loading.value = false;
                    //appModule.handleErrorResponse(form_data.value, ex);
                });
        };

        watch(() => props.isSelected, () => {
            if (props.isSelected) {
                appStoreDialogActions.setFooterActions([
                    {
                        text: $t("Save"),
                        class: "primary",
                        click: save,
                        loading: loading
                    }
                ]);
            }
        })

        return {
            accountFeature,
            accountFeatureSettings,
            selectedAccount,
            handleUpdate,
            customFields,
            layoutNumberField,
            layoutChoices,
            selectedLayout,
            changeAgreement,
            HelpModule
        };
    }
};
</script>
